import { apiClient } from './apiClient';

export interface Activity {
  id: string;
  type: 'user' | 'book' | 'vehicle' | 'system' | 'notification';
  title: string;
  description: string;
  timestamp: string;
  user: string;
  status: 'success' | 'error' | 'info';
}

export interface DashboardNotification {
  id: number;
  user_id: number;
  title: string;
  message: string;
  type: string;
  status: string;
  created_at: string;
  read_at?: string;
  related_activity?: {
    description: string;
    timestamp: string;
  };
}

export const activityService = {
  async getRecentActivities(limit: number = 10): Promise<Activity[]> {
    try {
      return await apiClient.get(`/dashboard/user-activity-stats?limit=${limit}`);
    } catch (error) {
      console.warn('Activity stats endpoint not available');
      return [];
    }
  },

  async getDashboardNotifications(skip: number = 0, limit: number = 10): Promise<DashboardNotification[]> {
    try {
      return await apiClient.get(`/dashboard/notifications?skip=${skip}&limit=${limit}`);
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        console.warn('Dashboard notifications requires authentication');
      } else if (error?.response?.status === 404) {
        console.warn('Dashboard notifications endpoint not found');
      } else {
        console.warn('Dashboard notifications error:', error?.message || error);
      }
      return [];
    }
  },

  async getDashboardOverview(): Promise<{
    total_users: number;
    recent_notifications: number;
    pending_approvals: number;
    user_roles: string[];
    last_updated: string;
  }> {
    try {
      return await apiClient.get('/dashboard/overview');
    } catch (error) {
      console.warn('Dashboard overview endpoint not available');
      return {
        total_users: 0,
        recent_notifications: 0,
        pending_approvals: 0,
        user_roles: [],
        last_updated: new Date().toISOString()
      };
    }
  },
};
